import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/landing/index";
import Home from "./pages/home/index";
import Login from "./pages/login/index";
import Admin from "./pages/admin/index";
import ServiceRegisterForm from "./pages/register-service/index";
import Premium from "./pages/premium/index";
import Account from "./pages/account/index";
import PremiumSuccess from "./pages/premium/success";
import Today from "./pages/today/index";
import Feedback from "./pages/feedback/index";
import Unsubscribe from "./pages/unsubscribe/index";
import Privacy from "./pages/privacy/index";
import Terms from "./pages/terms/index";
import Cjenik from "./pages/cjenik/index";
import Enterprise from "./pages/enterprise/index";
import "../src/css/root.scss";
import Register from "./pages/register";
import AutoLogin from "./pages/auto-login/index";
import NotFound from "./pages/not-found/index";
import { IntlProvider } from "react-intl";
import enLocale from "./utils/languages/en.json";
import croLocale from "./utils/languages/croatian.json";
import { useSelector } from "react-redux";
import Protected from "./routes/ProtectRoute";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// MUI theme aligned with the landing design system (src/pages/landing/style.scss).
const theme = createTheme({
  palette: {
    primary: { main: "#e08b1f", dark: "#c97a15", contrastText: "#21150a" },
    text: { primary: "#1c2231", secondary: "#5b6577" },
    background: { default: "#faf6ef", paper: "#ffffff" },
  },
  typography: {
    fontFamily: '"IBM Plex Sans", sans-serif',
    button: {
      fontFamily: '"Bricolage Grotesque", "IBM Plex Sans", sans-serif',
      fontWeight: 600,
      textTransform: "none",
    },
  },
  shape: { borderRadius: 10 },
});

function App() {
  const localeData = {
    en: enLocale,
    hr: croLocale,
  };

  const selectedLocale =
    useSelector((state) => state.lang.value) ||
    localStorage.getItem("lang") ||
    "hr";

  return (
    <IntlProvider
      locale={selectedLocale}
      messages={localeData[selectedLocale].messages}
    >
      <ThemeProvider theme={theme}>
        <div className="App">
          <BrowserRouter>
            <Routes>
            {/* Public marketing landing — anonymous visitors must never bounce to /login. */}
            <Route path="/" element={<Landing />} />
            <Route
              path="/pocetna"
              element={
                <Protected>
                  <Home />
                </Protected>
              }
            />
            <Route
              path="/admin"
              element={
                <Protected path="admin">
                  <Admin />
                </Protected>
              }
            />
            {/* Hidden admin-only Enterprise preview (noindex, not linked anywhere public). */}
            <Route
              path="/enterprise"
              element={
                <Protected path="admin">
                  <Enterprise />
                </Protected>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/auto-prijava" element={<AutoLogin />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/register-service"
              element={
                <Protected>
                  <ServiceRegisterForm />
                </Protected>
              }
            />
            <Route
              path="/danas"
              element={
                <Protected>
                  <Today />
                </Protected>
              }
            />
            <Route
              path="/pretplata"
              element={
                <Protected>
                  <Premium />
                </Protected>
              }
            />
            <Route
              path="/moj-racun"
              element={
                <Protected>
                  <Account />
                </Protected>
              }
            />
            <Route
              path="/pretplata/uspjeh"
              element={
                <Protected>
                  <PremiumSuccess />
                </Protected>
              }
            />
            <Route path="/feedback/:uuid" element={<Feedback />} />
            <Route path="/odjava/:token" element={<Unsubscribe />} />
            <Route path="/privatnost" element={<Privacy />} />
            <Route path="/uvjeti" element={<Terms />} />
            {/* Javni cjenik usluga (NN 101/2026) — dostupan bez prijave. */}
            <Route path="/cjenik" element={<Cjenik />} />
            <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </IntlProvider>
  );
}

export default App;
